module.exports = __webpack_public_path__ + "static/media/icon_expired.ec3f5231.svg";